import { Pipe, PipeTransform } from '@angular/core';
import { parseWhatsAppMarkdown } from './parse-whatsapp-markdown.util';

/** WhatsApp markdown to HTML, for rendering through `[innerHTML]`. Takes the text as WhatsApp renders it. */
@Pipe({
  name: 'kpWhatsappMarkdown',
  standalone: true,
})
export class KpWhatsappMarkdownPipe implements PipeTransform {
  transform(text: string | null | undefined): string {
    return parseWhatsAppMarkdown(text ?? '');
  }
}
